import { T, useGT } from 'gt-react';
import ConfirmDialog from '@/components/common/ConfirmDialog';

export function NoteDeleteDialog({
  open,
  onClose,
  onConfirm,
  message,
  loading,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  loading: boolean;
}) {
  const gt = useGT();
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={
        <T context="confirm dialog title when deleting a discussion note">
          Delete this note?
        </T>
      }
      message={message}
      confirmText={gt('Delete', { context: 'delete note confirm button' })}
      cancelText={gt('Cancel', { context: 'cancel delete note button' })}
      loading={loading}
      dangerous
      closeOnConfirm={false}
    />
  );
}
